import request from "@/axios.js";
/**
 * Deprecated Need to improve it
 */
export default class Task {
	/**
	 * Task class
	 * @property {string} commentary - a commentary.
	 * @property {string} link - a link.
	 * @property {boolean} recurrence - an recurrence.
	 * @property {Date} creation_date - a creation date.
	 * @property {number} status - a status.
	 * @property {Date} finished_date - a finished date.
	 * @property {number} archivate - a archivate.
	 * @property {number} frequency - a frequency.
	 * @property {number} contract_id - ID of a contract.
	 * @property {number} contract_society_id - ID of a society.
	 * @property {number} mission_id - ID of a mission.
	 */
	constructor(task) {
		this.id = task.id;
		this.commentary = task.commentary;
		this.link = task.link;
		this.status = task.status || 0;
		this.recurrence = task.recurrence;
		this.creation_date = task.creation_date;
		this.finished_date = task.finished_date;
		this.archivate = task.archivate;
		this.frequency = task.frequency;
		this.contract_id = task.contract_id;
		this.contract_society_id = task.contract_society_id;
		this.mission_id = task.mission_id;
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} society object
	 */
	static getFormFields() {
		return {
			commentary: "",
			link: "",
			status: 0,
			recurrence: 0,
			creation_date: null,
			finished_date: null,
			archivate: 0,
			frequency: 0,
			contract_id: null,
			contract_society_id: null,
			mission_id: null,
		};
	}

	static update(task, id) {
		return new Promise((resolve, reject) => {
			request.patch("task/update/" + id, task)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	static async get(id) {
		return new Promise((resolve, reject) => {
			request.get("task/get/" + id)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	static async getWithInvoice(id) {
		return new Promise((resolve, reject) => {
			request.get("task/getWithInvoice/" + id)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	/**
	 * Get tasks filtered by user and period with complex recurrence logic
	 * @param {Object} filters - Filter parameters
	 * @param {number} filters.userId - User ID to filter tasks by
	 * @param {string} filters.year - Year for filtering (e.g., "2024")
	 * @param {string} filters.month - Month for filtering (e.g., "09" for September)
	 * @param {number} filters.page - Page number for pagination (default: 1)
	 * @param {number} filters.limit - Items per page (default: 100)
	 * @param {boolean} filters.all - Include all tasks flag (default: false)
	 * @returns {Promise} Promise with filtered task data
	 */
	static async getTaskByFilter(filters) {
		const {
			userId,
			year,
			month,
			page = 1,
			limit = 100,
			all = 0
		} = filters;

		const params = new URLSearchParams({
			user_id: userId,
			year: year,
			month: month,
			page: page,
			limit: limit,
			all: all
		});

		return new Promise((resolve, reject) => {
			request.get(`task/filter?${params.toString()}`)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
}
